/* Lianne: Farbwelten (Entwurf Klickdummy, beschlossen 07.10.2026).
   Gemeinsam: Einordnung einer Garnfarbe (konfigurator.farbcode) in sechs Farbwelten und die für die Sitzung
   gemerkte Farbwelt (sessionStorage „lfd-welt“, auch vom Strickset-Finder gesetzt).
   Produktseite (snippets/strickset-variants.liquid, [data-ss-farbwelten]): drei Wege im Farbbereich, genau einer
   ist aktiv – Lisas Empfehlungen · „nach Stimmung“ (Farbwelt, „Neu mischen“) · „Eigene Auswahl“.
   Dieselben Regeln stehen in scripts/setze-finder-daten.mjs (Vorschau auf den Produktkarten). */
(function () {
  if (window.LianneFarbwelt) return;

  var WELTEN = [['natur', 'Natur & gedeckt'], ['warm', 'Warm & erdig'], ['kuehl', 'Kühl & frisch'],
    ['zart', 'Zart & hell'], ['kraeftig', 'Kräftig & bunt'], ['dunkel', 'Dunkel & elegant']];
  function label(k) { for (var i = 0; i < WELTEN.length; i++) if (WELTEN[i][0] === k) return WELTEN[i][1]; return k; }
  function schluessel(l) { for (var i = 0; i < WELTEN.length; i++) if (WELTEN[i][1] === l || WELTEN[i][0] === l) return WELTEN[i][0]; return null; }
  function welt(hex) {
    var h = String(hex || '').replace('#', '').trim(); if (h.length !== 6) return null;
    var r = parseInt(h.slice(0, 2), 16) / 255, g = parseInt(h.slice(2, 4), 16) / 255, b = parseInt(h.slice(4, 6), 16) / 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), L = (mx + mn) / 2, d = mx - mn, S = d ? d / (1 - Math.abs(2 * L - 1)) : 0, H = 0;
    if (d) { H = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4; H *= 60; if (H < 0) H += 360; }
    if (L < .22) return 'dunkel';
    if (S < .18 || (S < .3 && L > .7)) return 'natur';
    if (L > .72) return 'zart';
    if ((H >= 290 || H <= 5) && L >= .66 && S >= .35) return 'zart'; // helle Rosa/Pink (Bubblegum) – Lisa 07.10.2026
    if (S > .55 && L > .3 && L < .68) return 'kraeftig';
    return H < 65 || H > 330 ? 'warm' : 'kuehl';
  }
  function gemerkt() { try { return schluessel(sessionStorage.getItem('lfd-welt')); } catch (e) { return null; } }
  function merken(k) { try { if (k) sessionStorage.setItem('lfd-welt', k); else sessionStorage.removeItem('lfd-welt'); } catch (e) {} }
  window.LianneFarbwelt = { WELTEN: WELTEN, label: label, schluessel: schluessel, welt: welt, gemerkt: gemerkt, merken: merken };

  /* ── Produktseite ── */
  function produktseite() {
    var box = document.querySelector('[data-ss-farbwelten]');
    if (!box) return;
    var selektoren = [].slice.call(document.querySelectorAll('strickset-selector')).filter(function (s) { return s.radios && s.radios.length; });
    if (!selektoren.length) return;
    // Optionen je Garn (data-index = Position in strickset_config.garne)
    var garne = selektoren.map(function (s) {
      return { el: s, idx: parseInt(s.getAttribute('data-index'), 10), handle: s.getAttribute('data-product-handle') || '',
        opts: [].map.call(s.radios, function (r) {
          return { id: r.value, t: r.getAttribute('data-title'), w: welt(r.getAttribute('data-hx')), av: !r.hasAttribute('data-crossout'), inv: parseInt(r.getAttribute('data-inv'), 10) };
        }) };
    }).sort(function (a, b) { return a.idx - b.idx; });
    var haupt = garne[0];
    function inWelt(g, k) { return g.opts.filter(function (o) { return o.av && o.w === k; }).sort(function (a, b) { return (isNaN(b.inv) ? 99 : b.inv) - (isNaN(a.inv) ? 99 : a.inv); }); }
    var welten = WELTEN.map(function (x) { return x[0]; }).filter(function (k) { return inWelt(haupt, k).length; });
    if (!welten.length) return;
    var kacheln = [].slice.call(document.querySelectorAll('.color-collection-tile'));
    var hatLisa = kacheln.length > 0;
    var z = { quelle: hatLisa ? 'lisa' : null, welt: null, mix: 0 };
    var automatisch = false;

    function farbenFuer(k, mix) {
      var wahl = {}, benutzt = {};
      if (!mix) { // Passt eine von Lisas Empfehlungen zur Welt, ist sie die beste Kombination
        for (var r = 0; r < kacheln.length; r++) {
          var titel = (kacheln[r].getAttribute('data-collection-colors') || '').split(','), treffer = 0, gesamt = 0;
          garne.forEach(function (g) { var o = g.opts.filter(function (x) { return x.t === titel[g.idx]; })[0]; if (o) { gesamt++; if (o.w === k) treffer++; } });
          if (gesamt && treffer * 2 >= gesamt) { garne.forEach(function (g) { var o = g.opts.filter(function (x) { return x.t === titel[g.idx] && x.av; })[0]; if (o) wahl[g.idx] = o.id; }); break; }
        }
      }
      // Jede Position bekommt eine Farbe der Welt: möglichst verschiedene, bei mehr Garnen als Farben wiederholen sie sich
      // (Rückmeldung 07.10.2026: beim Cardiducoeur blieben sonst ab der 6. Farbe die alten Farben stehen).
      // „Neu mischen“ verschiebt die ganze Palette, nicht nur den Anfang.
      var versatz = mix ? mix * 7 : 0, je = {};
      garne.forEach(function (g) {
        var pos = je[g.handle] = (je[g.handle] === undefined ? 0 : je[g.handle] + 1); // Position innerhalb desselben Garns
        if (wahl[g.idx]) return;
        var L = inWelt(g, k); if (!L.length) return;
        // „Neu mischen“: Reihenfolge der Farben je Durchgang anders (fest je mix, damit es nachvollziehbar bleibt)
        if (mix) L = L.map(function (x) { return { x: x, s: (parseInt(String(x.id).slice(-7), 10) * (mix * 9973 + 17)) % 10007 }; }).sort(function (a, b) { return a.s - b.s; }).map(function (y) { return y.x; });
        var o = null;
        for (var n = 0; n < L.length && !o; n++) { var x = L[(versatz + pos + n) % L.length]; if (!benutzt[g.handle + ':' + x.id]) o = x; }
        if (!o) o = L[(versatz + pos) % L.length];
        wahl[g.idx] = o.id; benutzt[g.handle + ':' + o.id] = true;
      });
      return wahl;
    }
    function anwenden(k, mix) {
      var wahl = farbenFuer(k, mix);
      automatisch = true;
      garne.forEach(function (g) { if (wahl[g.idx]) g.el._selectVariant(String(wahl[g.idx])); });
      setTimeout(function () { automatisch = false; }, 0);
      kacheln.forEach(function (t) { t.classList.remove('color-collection-tile--active'); });
      var h = document.querySelector('strickset-handler'); if (h) h._activeCollectionIndex = null;
      z = { quelle: 'welt', welt: k, mix: mix || 0 };
      merken(k);
      zeichnen();
    }
    function zeichnen() {
      var dots = function (k) { return inWelt(haupt, k).slice(0, 4).map(function (o) { var g = haupt.el.querySelector('input[value="' + o.id + '"]'); return '<i style="background:#' + String(g.getAttribute('data-hx')).replace('#', '') + '"></i>'; }).join(''); };
      box.innerHTML = '<p class="ss-fw-titel">' + (hatLisa ? 'Oder nach Stimmung' : 'Farben nach Stimmung') + '</p>' +
        '<div class="ss-welten">' + welten.map(function (k) {
          var an = z.quelle === 'welt' && z.welt === k;
          return '<button type="button" class="ss-welt' + (an ? ' is-on' : '') + '" data-ss-welt="' + k + '" aria-pressed="' + an + '"><span class="ss-welt__d">' + dots(k) + '</span>' + label(k) + '</button>';
        }).join('') + '</div>' +
        '<div class="ss-fw-status">' + (z.quelle === 'welt' ? '<button type="button" class="ss-fw-mix" data-ss-mix>↻ Neu mischen</button><span>Andere Kombination aus „' + label(z.welt) + '“</span>'
          : z.quelle === 'eigen' ? '<span><b>Eigene Auswahl</b> – Farben einzeln geändert</span>' : '') + '</div>';
      box.hidden = false;
      // waagerechte Reihe (Handy): gewählte Farbwelt in den Sichtbereich holen, ohne die Seite zu scrollen
      var reihe = box.querySelector('.ss-welten'), an = box.querySelector('.ss-welt.is-on');
      if (reihe && an && reihe.scrollWidth > reihe.clientWidth) reihe.scrollLeft = Math.max(0, an.offsetLeft - reihe.offsetLeft - 16);
    }
    // Klicks: Capture-Phase, weil das Theme im Kaufbereich die Weitergabe stoppt
    document.addEventListener('click', function (e) {
      var w = e.target.closest('[data-ss-welt]'); if (w) { e.preventDefault(); anwenden(w.getAttribute('data-ss-welt'), 0); return; }
      if (e.target.closest('[data-ss-mix]')) { e.preventDefault(); anwenden(z.welt, (z.mix || 0) + 1); return; }
      if (e.target.closest('.color-collection-tile')) { automatisch = true; setTimeout(function () { automatisch = false; z = { quelle: 'lisa', welt: null, mix: 0 }; zeichnen(); }, 0); }
    }, true);
    document.addEventListener('strickset:variant-changed', function () {
      if (automatisch || z.quelle === 'eigen') return;
      z = { quelle: 'eigen', welt: null, mix: 0 };
      kacheln.forEach(function (t) { t.classList.remove('color-collection-tile--active'); });
      zeichnen();
    });
    // Start: Farbwelt aus dem Finder (?welt=…) oder die gemerkte, sonst wie bisher (Lisas erste Empfehlung)
    var q = new URLSearchParams(location.search);
    var start = schluessel(q.get('welt')) || gemerkt();
    var ersatz = document.querySelector('[data-ss-fw-ersatz]'); if (ersatz) ersatz.hidden = true;
    if (start && welten.indexOf(start) >= 0 && !q.get('farben')) anwenden(start, 0); else zeichnen();

    // Zurück zu den Finder-Ergebnissen
    var zurueck = null; try { zurueck = sessionStorage.getItem('lfd-zurueck'); } catch (e) {}
    var titel = document.querySelector('.product__title');
    if (q.get('fd') && zurueck && titel && !document.querySelector('.ss-zurueck')) {
      var a = document.createElement('a'); a.className = 'ss-zurueck'; a.href = zurueck;
      a.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true"><path d="M10 3L5 8l5 5" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>' +
        '<svg class="lfd-sym" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14.6 19.8C11.2 22 5.4 20.8 4.2 16C3 11.2 6.4 7.8 10.2 7.8C14.4 7.8 17.4 11.2 16.8 15C16.3 18.2 13.6 20.4 10.8 20.6"/><path d="M5 12.4C8.6 12.4 12.2 15.2 13.2 20.4"/><path d="M7.6 8.8C11.2 10.2 14.6 13.4 16 17.4"/><path d="M18.6 3.8C17.9 3 16.5 3.1 16.2 4.4C15.9 5.8 17 7.2 18.4 7.1C19.9 7 21.2 5.6 21.5 4.2C21.8 2.8 20.9 1.9 19.9 2.1C19.4 2.2 19 2.7 18.6 3.8Z" fill="currentColor" stroke-width="1"/></svg>Deine Auswahl'; // Finder-Symbol wie snippets/lianne-finder-symbol.liquid
      a.setAttribute('aria-label', 'Zurück zu Deiner Auswahl');
      // Wurde hier eine andere Farbwelt gewählt, gilt sie auch für die Ergebnisse (sonst stünde dort die alte)
      a.addEventListener('click', function () {
        var u = new URL(zurueck, location.origin), p = 'filter.p.m.custom.finder_farbwelt';
        if (z.quelle === 'welt' && z.welt && u.searchParams.get(p) && u.searchParams.get(p) !== label(z.welt)) {
          u.searchParams.set(p, label(z.welt)); u.searchParams.delete('page'); a.href = u.pathname + u.search;
        }
      }, true);
      // Als Chip über Bild und Infos (10.10.2026) – vorher stand der Link zwischen Marke und Titel
      var produkt = titel.closest('.product'), anker = produkt || titel;
      anker.parentElement.insertBefore(a, anker);
    }
  }
  // Erst starten, wenn die Farbwähler des Konfigurators verbunden sind (strickset-selector.radios gesetzt)
  function starten() {
    if (!document.querySelector('[data-ss-farbwelten]')) return;
    var fertig = function () { setTimeout(produktseite, 0); };
    if (window.customElements && customElements.whenDefined) customElements.whenDefined('strickset-selector').then(fertig); else fertig();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starten); else starten();
})();
